import { isCheckoutSimplifiedEnabled } from '@Config/features.config';
import { remoteConfigSelector } from '@Redux/modules/settings/remoteConfig/selectors';
import { useBuyNowPayLater } from '@Utils/context/BuyNowPayLaterContext';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

interface IFeatureFlags {
	isSimplifiedCheckoutEnabled: boolean;
}

export const useFeatureFlags = (): IFeatureFlags => {
	const remoteFeatureConfig = useSelector(remoteConfigSelector);
	const { isBuyNowPayLaterFlow, isBuyNowPayLaterInCart } = useBuyNowPayLater();

	return useMemo(
		() => ({
			isSimplifiedCheckoutEnabled:
				isCheckoutSimplifiedEnabled(remoteFeatureConfig) && !isBuyNowPayLaterFlow && !isBuyNowPayLaterInCart,
		}),
		[remoteFeatureConfig, isBuyNowPayLaterFlow, isBuyNowPayLaterInCart]
	);
};
